/**
 * Stock photo URLs for the CWC Student Recruitment site.
 * All photos sourced from Unsplash (free, no attribution required for commercial use).
 * Uses Unsplash CDN with on-the-fly resizing via ?w= parameter.
 */

const U = 'https://images.unsplash.com/photo-';

const photos = {
  // Hero background (w=1600 for full-width)
  hero: `${U}1523240795612-9a054b0db644?w=1600&q=80`,           // students working on laptops

  // CTA section background
  cta: `${U}1522071820081-009f0129c71c?w=1600&q=80`,            // diverse team in modern office

  // "What You Get" card images (w=600 for cards)
  realWork: `${U}1581091226825-a6a2a5aee158?w=600&q=80`,        // person with laptop doing real work
  cisspFeedback: `${U}1552664730-d307ca884978?w=600&q=80`,      // mentor coaching session
  portfolio: `${U}1454165804606-c3d57bc86b40?w=600&q=80`,       // documents/portfolio on desk
  schedule: `${U}1506784983877-45594efa4cbe?w=600&q=80`,        // calendar / planner

  // Trust bar card images (w=400 for smaller trust items)
  trustClients: `${U}1521791136064-7986c2920216?w=400&q=80`,    // handshake / client meeting
  trustReview: `${U}1531482615713-2afd69097998?w=400&q=80`,     // expert reviewing on laptop
  trustMethodology: `${U}1434626881859-194d67b2b86f?w=400&q=80`, // checklist / structured docs
  trustInsured: `${U}1450101499163-c8848c66ca85?w=400&q=80`,    // professional office / supervised
};

export default photos;
